import {Injectable} from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
} from '@angular/router';
import {environment} from "@galec/environments/environment";
import {LangService} from "@galec/services/global/lang.service";

@Injectable({
    providedIn: 'root'
})
/**
 * Check if site in maintenance
 */
export class MaintenanceGuard implements CanActivate {
    constructor(
        private router: Router,
        private readonly langService: LangService,
    ) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot) {
        if (environment.maintenance) {
            this.langService.navigate('/maintenance');
            return false;
        }
        return true;
    }
}
